// Components
import { Typography, Box } from "@mui/material";

// Styles
import { styles } from "../styles";

// Constants
import { PAN_AM_ID } from "Constants/ClinicConstants";

// Resources
import { useTranslation } from "react-i18next";

const PanAmNote = ({ clinicId, isMBS = false }) => {
  const { t } = useTranslation();
  if (!PAN_AM_ID.includes(clinicId)) return null;
  return (
    <Typography
      variant="caption"
      sx={{
        textAlign: "left",
        px: 1,
        pt: 0.5,
        boxSizing: "border-box",
        width: "100%",
        display: "block",
      }}
    >
      <Box component="span" sx={styles.importantNoteHeader}>
        {t("panAmNote.noteTitle")}
      </Box>
      {t(isMBS ? "panAmNote.noteContentMBS" : "panAmNote.noteContent")}
    </Typography>
  );
};

export default PanAmNote;
